export default "__VITE_ASSET__DlSaQmNr__"